import { DASHBOARD_PAGE } from "@/constants/definitions";

// Add this in the component did mount of the root
export function loadDashboard(navigate: (path: string) => void): void {
  // Add the fade in transition effect
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.className = "root fadein";
  }
  // Go to the dashboard
  navigate(DASHBOARD_PAGE);
}
